import { Component } from "react";
import PropTypes from "prop-types";
import { toast } from "src/react/components/toast";
import { pcaFind, pcaRetrieve } from "src/services/pca-predict";
import trackError from "src/lib/track-error";
import { getCountryCodeByName } from "src/data/country-codes";
import AddressLookupUI from "./components/address-lookup-ui";

const defaultState = {
  addressList: [],
  address: {
    firstLine: "",
    secondLine: "",
    city: "",
    postcode: "",
  },
};

class AddressLookup extends Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
    onSetAddress: PropTypes.func.isRequired,
    country: PropTypes.string.isRequired,
    onManualEntry: PropTypes.func,
  };

  static defaultProps = {
    children: AddressLookupUI,
    onSetAddress: () => {},
    onManualEntry: () => {},
  };

  state = {
    ...defaultState,
    searchTerm: "",
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.address !== this.state.address) {
      this.props.onSetAddress(this.state.address);
    }
  }

  findAddress = (searchTerm, id) => {
    const countryCode = getCountryCodeByName(this.props.country);

    if (!searchTerm || !countryCode) return;

    pcaFind(countryCode, searchTerm, id).then(
      (data) => this.processFindSuccess(searchTerm, data),
      this.processError
    );
  };

  retrieveAddress = (id) => {
    pcaRetrieve(id).then((address) => {
      const showComercial =
        address.Type === "Commercial" && address.Company !== "";
      const formattedAddress = {
        firstLine: showComercial ? address.Company : address.Line1,
        secondLine: showComercial ? address.Line1 : address.Line2,
        city: address.City,
        postcode: address.PostalCode,
        country: this.props.country,
      };
      this.setState(() => ({ address: formattedAddress }));
      this.props.onManualEntry();
    }, this.processError);
  };

  processError = (error) => {
    toast.error(
      "Sorry, we couldn't process your address. Please enter manually.",
      { autoClose: 8000 }
    );
    this.props.onManualEntry();
    trackError({ errorMessage: "AddressLookup - processError", error });
  };

  processFindSuccess = (searchTerm, data = []) => {
    if (data && data.length === 1 && data[0].Type !== "Address") {
      this.findAddress(searchTerm, data[0].Id);
    } else {
      this.setState(() => ({ addressList: data }));
    }
  };

  handleSearchAddress = (event) => {
    const searchTerm = event.target.value;
    const shouldResetAddress = searchTerm === "" || searchTerm.length < 3;
    const newState = {
      searchTerm,
      ...(shouldResetAddress && { ...defaultState }),
    };

    this.setState(() => newState);

    if (!shouldResetAddress) {
      this.findAddress(searchTerm);
    }
  };

  render() {
    const { children, onManualEntry, ...props } = this.props;
    return children({
      triggerManualEntry: onManualEntry,
      findAddress: this.findAddress,
      retrieveAddress: this.retrieveAddress,
      onSearchAddress: this.handleSearchAddress,
      address: this.state.address,
      addressList: this.state.addressList,
      searchTerm: this.state.searchTerm,
      ...props,
    });
  }
}

export default AddressLookup;
